import React, {Component} from 'react';
import $ from 'jquery';
import {
    AJAX,
    showPreloader,
    show_success_popup,
    hidePreloader,
    cross_form_errors,
    addStepLog,
    setUrlSinglePageApp
} from "../functions";
import {Redirect} from "react-router-dom";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {withRouter} from "react-router";

class SendCommentPage extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.handleUserInput = this.handleUserInput.bind(this);
        this.sendComment = this.sendComment.bind(this);
        this.handleSetPage({name: 'send_comment', params: false});
        this.state = {redirect: false, comment: null};

        if (this.props.booking_state.comment) {
            this.state.comment = this.props.booking_state.comment;
        }

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    handleSetPage(options) {
        if (options.name == 'send_comment')
            addStepLog('Send comment Page');
        this.props.handleSetPage(options);
    }

    handleUserInput = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({[name]: value});
    };

    sendComment(event) {
        addStepLog('Press button goNext on Send comment Page');
        let fields = this.props.field_list.send_comment;
        let btn = event.target;
        let form_inputs = $(btn).closest('.form-inputs');
        let params = {
			session_key: this.props.session_key,
            comment: this.state.comment,
			action: 'api/booking/send_comment'
		};

        for (let item in fields) {
            let el = form_inputs.find('[name='+fields[item]+']');
            if (el.length) {
                params[fields[item]] = el[0].value;
            }
        }

        let t = this;

        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: function () {
                showPreloader();
            },
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                    show_success_popup('Thank you, your comments have been successfully sent.');
                    t.props.handleSetBookingState(resp.data.booking_state);
                    setTimeout(() => t.setState({redirect: true}), 2000);

                    /*for (let item in fields) {
                        let el = form_inputs.find('[name='+fields[item]+']');
                        if (el.length) {
                            el[0].value = '';
                        }
                    }*/

                } else if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                    showPopupWithGoBack(resp.errors.main);
                }

                cross_form_errors(resp.errors !== undefined && resp.errors.form !== undefined ? resp.errors.form : {}, fields, form_inputs);
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    render() {
        if (this.state.redirect)
            return <Redirect push to="/vehicle_state" />;

        return (<>
            <RedirectOnlyHome />
            <div className={'value-space'}>
                <div className="row">
                    <div className="offset-2 col-8">
                        <h1 className="my-4">Are there any additional comments about the hire before you can lock your vehicle?</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-2 col-8 text-center form-inputs">
                        <div className="form-group mb-4">
                            <textarea name="comment" className="form-control" placeholder="Answer" defaultValue={this.state.comment} onChange={this.handleUserInput}/>
                            <div id="comment_errors" />
                        </div>
                        <div className="go-btn go-next mx-auto" onClick={()=>this.sendComment(event)}/>
                    </div>
                </div>
            </div>
        </>);
    }
}

const SendCommentPageR = withRouter(SendCommentPage);
export default SendCommentPageR;